import { render } from "./ViewMoreTeacher.vue?vue&type=template&id=48adc518&scoped=true"
import script from "./ViewMoreTeacher.vue?vue&type=script&lang=js"
export * from "./ViewMoreTeacher.vue?vue&type=script&lang=js"

import "./ViewMoreTeacher.vue?vue&type=style&index=0&id=48adc518&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48adc518"]])

export default __exports__